import React, { createContext, useState, memo, useContext } from 'react'

import GroupFacilityMenu from './GroupFacilityMenu'
import SearchInput from 'components/CommonUI/SearchInput/SearchInput'
import { routingConstants } from 'constants/routingConstants'
import { getProfileGroupsSelector } from 'redux/reducers/profile'
import { getGroupIdSelector } from 'redux/reducers/overview'
import { useShallowEqualSelector } from 'custom-hooks'
import Link from 'components/CommonUI/Link/Link'

export const GroupContext = createContext('')

const FacilityDropDownMenu = ({ itemsType = 'locations' }) => {
  const [searchValue, setSearchValue] = useState('')

  const _title = itemsType === 'locations' ? 'FACILITIES' : 'GROUPS'

  return (
    <GroupContext.Provider value={searchValue}>
      <div className="facility_menu_container">
        <div className="facility_menu_item search_block">
          <Title title="SEARCH" />
          <SearchInput
            value={searchValue}
            handleChange={setSearchValue}
            classNameContainer="facility_menu__search_input"
            placeholder="Search facility or equipment"
          />
        </div>
        <FacilityMenuItem title={_title} itemsType={itemsType} />
      </div>
    </GroupContext.Provider>
  )
}

const FacilityMenuItem = memo(({ title, itemsType }) => {
  return (
    <div className="facility_menu_item">
      <Title title={title} />
      {itemsType === 'locations' ? <GroupFacilityMenu /> : <GroupsMenu />}
    </div>
  )
})

const Title = memo(({ title }) => {
  return <span className="facility_menu_title">{title}</span>
})

const GroupsMenu = () => {
  const searchValue = useContext(GroupContext)
  const selecteOverviewId = useShallowEqualSelector(getGroupIdSelector)
  const groups = useShallowEqualSelector(getProfileGroupsSelector)

  const saerchGroup = groups.filter((group) =>
    String(group.name).toLowerCase().includes(searchValue.toLowerCase())
  )

  return saerchGroup.map((group) => {
    const activeClassName = selecteOverviewId === group.id ? 'active' : ''
    return (
      <Link
        key={group.id}
        to={`${routingConstants.overview}/${group.id}`}
        className={`grop_menu_item ${activeClassName}`}
      >
        {group.name}
      </Link>
    )
  })
}

export default FacilityDropDownMenu
